import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {NotificationService} from "../../services/NotificationService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {AssetService} from "../../services/AssetService";
import {Asset} from "../../entities/Asset";
import {PagingModel} from "../paging/PagingModel";

export class CmdCenterAssetCmdModel extends PagingModel<Asset> {
    static $inject = ['$q','AssetService','CustomFieldNameService','ApplicationSettingService','NotificationService'];
    selectedAsset:Asset;
    errorMessage:string = "";
    addedAssets:Asset[] = [];
    selectedAddedAssets:Asset[] = [];
    constructor($q:ng.IQService,
                public pagingService:AssetService,
                public customFieldNameService:CustomFieldNameService,
                public applicationSettingService:ApplicationSettingService,
                public notifyService:NotificationService) {
        super($q, pagingService, notifyService);
    }
    init(){

    }
    entityName():string{
        return "asset";
    }
    displayName():string{
        return "VTagAssets";
    }
    getPagedPromise():ng.IPromise<any>{
      return this.pagingService.getVTagAndGpsAssetsPaged(this.search,this.page,this.pageSize,this.orderColumn,this.orderDirection);
    }

    getCountPromise():ng.IPromise<any>{
      return this.pagingService.getVTagAndGpsAssetsCount(this.search);
    }
    transformItem(entity:Asset){
    }
    getColumnDefs():ng.IPromise<void>{
        return this.customFieldNameService.getAssetColumnDefs().then((data)=>{
            this.nameValuePairs = data;
        });
    }
    selectionChanged():void{
        if(this.selectedItems.length > 0)
            this.selectedAsset = this.selectedItems[0];
        else
            this.selectedAsset = null;
    }
    addAddedSelected(item:any):void{
        var foundIndex = this.selectedAddedAssets.indexOf(item);
        if(foundIndex != -1)
            this.selectedAddedAssets[foundIndex] = item;
        else
            this.selectedAddedAssets.push(item);
    }
    removeAddedSelected(item:any):void{
        var foundIndex = this.selectedAddedAssets.indexOf(item);
        if(foundIndex != -1)
            this.selectedAddedAssets.splice(foundIndex,1);
    }
    CMDACCELSENSOR="Accel Sensor";
    CMDSETTHRESHOLDACCELUPPERG="Set Threshold Accel Upper";
    CMDSETTHRESHOLDLIGHTLEVELUPPERLX="Set Threshold Light Level Upper";
    CMDSETTHRESHOLDBATTERY = "Set Threshold Battery";
    CMDSETTHRESHOLDTEMPERATUREUPPER = "Set Threshold Temperature Upper";
    CMDSETTHRESHOLDTEMPERATURLOWER = "Set Threshold Temperature Lower";
    CMDSETDWELLTIME = "Set Dwell Time";
    CMDGETTHRESHOLD = "Get Threshold";
    CMDGETALARMS = "Get Alarms";
    CMDCLEARALARMS = "Clear Alarms";
    commands:string[] = [this.CMDSETTHRESHOLDACCELUPPERG,this.CMDSETTHRESHOLDBATTERY,
        this.CMDSETTHRESHOLDTEMPERATUREUPPER,this.CMDSETTHRESHOLDTEMPERATURLOWER,
        this.CMDSETDWELLTIME,this.CMDGETTHRESHOLD];
    selectedCommand = this.CMDSETTHRESHOLDACCELUPPERG;
}
